import React, { useContext } from "react";
import BqnContext from "common/BqnContext";
import styled from "styled-components";
import SelectAutocomplete from "./SelectAutocomplete";

const nodeLabel = ({ bqnId, hostname }) =>
  hostname === undefined ? `BQN ${bqnId}` : `BQN ${bqnId}: ${hostname}`;

export const SelectWrapper = styled.div`
  width: 220px;
  height: 20px;
  position: relative;
  .MuiAutocomplete-root input {
    background-color: transparent;
  }

  .material-icons {
    font-size: 20px;
    margin-top: 4px;
  }
`;

export function BqnSelector() {
  const {bqnId, clusterStatus, bqns, loginBqnId, setBqnId, loadHostnames} =
    useContext(BqnContext);
  const asOptions = (nodesGiven) => [
    {
      label: "Cluster",
      value: "all",
    },
    ...nodesGiven.map((node) => ({
      // The label names the BQN in the input, and the option in the list.
      label: nodeLabel(node),
      value: Number(node.bqnId),
      offline: node.offline,
      // The BQN serving the GUI is the one marked in the list.
      icon: Number(node.bqnId) === Number(loginBqnId) ? "person" : null,
    })),
  ];
  // Until the list is asked for, the BQNs known name themselves in the input.
  const options = asOptions(bqns ?? []);

  // The cluster is read again, and its BQNs named, before the list is shown.
  // The BQNs of the time before are kept when it cannot be read.
  const loadOptions = () => loadHostnames().catch(console.error);

  return clusterStatus?.mode === "standalone" ? null : (
    <SelectWrapper id="bqn-selector">
      <SelectAutocomplete
        title="Bqns"
        name="bqns"
        icon="storage"
        onOpen={loadOptions}
        options={options}
        selected={bqnId === 'all' ? options[0] :
          // A BQN not listed yet names itself, so that the input is not empty.
          options.find(option => String(option.value) === String(bqnId)) ??
            {label: nodeLabel({bqnId}), value: bqnId}
        }
        onChange={(value) => {
          setBqnId(value);
        }}
        // The options are built again on every render: compare their values.
        isOptionEqualToValue={(option, value) =>
          String(option.value) === String(value?.value ?? value)
        }
        disableClearable={true}
        getOptionDisabled={(node) => node.offline}
      />
    </SelectWrapper>
  );
}
